import React from 'react';
import Favico, { favicojs } from './favico';

const favico: favicojs.Favico | undefined = typeof window !== 'undefined' ? new Favico() : undefined;

export interface IFaviconManager {
  badge(count: number): void;
}

export const useFaviconManager = (): IFaviconManager => {
  return React.useMemo<IFaviconManager>(
    () => ({
      badge(count) {
        favico?.badge(count);
      },
    }),
    [],
  );
};
